import { asMultiStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
var parts = ['container', 'track', 'thumb'];
function baseStyleTrack(props) {
  var {
    theme
  } = props;
  return {
    borderRadius: 'full',
    p: '2px',
    width: 'var(--slider-track-width)',
    height: 'var(--slider-track-height)',
    transition: 'all 120ms',
    bg: 'white',
    border: "1px solid ".concat(getColor(theme, 'blue.600')),
    _focus: {
      boxShadow: "0 0 0.1875rem 0.125rem ".concat(getColor(theme, 'blue.300'))
    },
    _disabled: {
      bg: '#F0F0F0',
      border: "1px solid ".concat(getColor(theme, 'grey.400')),
      cursor: 'not-allowed',
      '.tqc-switch__thumb': {
        bg: 'grey.800'
      }
    }
  };
}
var baseStyleThumb = {
  bg: 'blue.600',
  transition: 'transform 250ms',
  borderRadius: 'inherit',
  width: 'var(--slider-track-height)',
  height: 'var(--slider-track-height)',
  _checked: {
    transform: 'translateX(var(--slider-thumb-x))'
  }
};
var baseStyle = props => ({
  container: {
    '--slider-track-diff': 'calc(var(--slider-track-width) - var(--slider-track-height))',
    '--slider-thumb-x': 'var(--slider-track-diff)',
    _rtl: {
      '--slider-thumb-x': 'calc(-1 * var(--slider-track-diff))'
    }
  },
  track: baseStyleTrack(props),
  thumb: baseStyleThumb
});
var sizes = {
  sm: {
    container: {
      '--slider-track-width': '1.375rem',
      '--slider-track-height': '0.75rem'
    }
  },
  md: {
    container: {
      '--slider-track-width': '2.5rem',
      '--slider-track-height': '1rem'
    }
  },
  lg: {
    container: {
      '--slider-track-width': '2.875rem',
      '--slider-track-height': '1.5rem'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  sizes,
  defaultProps
});